import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Size } from '@jetbrains/ring-ui/components/toggle/toggle';
import RingFieldsList from '@common/form/ring-fields-list';
import { useFeatureFlag } from '@common/server-config-context/server-config-context';
import RegisteredToggle from '@common/hook-form/registered-toggle';
import styles from './jetbrains-ai-provider-form.css';
export function JetbrainsAiProviderForm({ form }) {
    const enableCloneFinder = useFeatureFlag('enableCloneFinder');
    if (!enableCloneFinder) {
        return null;
    }
    return (_jsx(RingFieldsList, { children: _jsxs("div", { children: [_jsx(RegisteredToggle, { name: "provider.jetbrains.enableCloneFinder", control: form.control, size: Size.Size16, children: "Enable Clone Finder" }), _jsx("div", { className: styles.toggleNotice, children: _jsx("p", { children: "Allow filtering out code snippets violating IP rights in code completion results." }) })] }) }));
}
